










































import {
  defineComponent,
  ref,
  onMounted,
  onUpdated,
  onBeforeUnmount
} from '@vue/composition-api'

import ServiceProviderSelector from './ServiceProviderSelector.vue'
import DeliveryDetails from './DeliveryDetails.vue'
import { AnslSelectionButton } from '@/components/common'

import { findHighestElementsHeight } from '@/utils/style.utils'
import {
  operatorChangeDateOptions
} from '@/utils/date.utils'

export default defineComponent({
  components: {
    AnslSelectionButton,
    ServiceProviderSelector,
    DeliveryDetails
  },
  props: {
    offers: {
      type: Array,
      default: () => []
    },
    offerId: {
      type: Number,
      required: false
    }
  },
  setup (_, context) {
    const handleSelection = (id: number | null) => context.emit('select', id)

    const offerIsBredband = (tags: string[] | null) => tags?.includes('Bredband')
    const offerIsTV = (tags: string[] | null) => tags?.includes('TV')
    const offerIsBlackWeek = (tags: string[] | null) => tags?.includes('BlackWeek')

    const minimumOfferHeight = ref(0)
    const setOfferHeights = () => {
      minimumOfferHeight.value = findHighestElementsHeight(context.refs.header as HTMLElement[])
    }

    onUpdated(() => {
      setOfferHeights()
    })

    onMounted(() => {
      setOfferHeights()
      window.addEventListener('resize', setOfferHeights)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setOfferHeights)
    })

    return {
      handleSelection,
      offerIsBredband,
      offerIsTV,
      offerIsBlackWeek,
      minimumOfferHeight,
      operatorChangeDateOptions
    }
  }
})
